var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './bobInfo.module.css';
import clsx from 'clsx';
export var BobInfo = function (_a) {
    var title = _a.title, text = _a.text, _b = _a.iconPosition, iconPosition = _b === void 0 ? 'left' : _b;
    return (_jsxs("div", __assign({ className: styles.wrapper }, { children: [_jsx("img", { className: clsx(styles.image, styles["iconPosition__".concat(iconPosition)]), src: "https://cdn.toppy.nl/frontend/Toppy/base-v2/nl_NL/images/bob.6866482c.png" }), _jsxs("span", __assign({ className: clsx(styles.info, styles["arrowPosition__".concat(iconPosition)]) }, { children: [_jsx("p", __assign({ className: styles.title }, { children: title })), _jsx("p", __assign({ className: styles.text }, { children: text }))] }))] })));
};
export default BobInfo;
